import React from 'react';
import { Button, Modal, Form, Message } from 'semantic-ui-react'
import ModalAddV2TrainingModule from './add_v2_training_module'

class ModalEditV2TrainingModule extends ModalAddV2TrainingModule {
  constructor(props){
    super(props);

    const { existingModules, moduleData } = props;
    const { name, default_frequency, category, shec_discipline, run_time, delivery, link } = moduleData;
    const { categories, shec_disciplines, deliveries } = this.state;

    this.state = {
      name,
      default_frequency,
      category,
      shec_discipline,
      run_time,
      delivery,
      link,
      errorModuleName: false,
      errorDefaultFrequency: false,
      errorCategory: false,
      errorDuplicateModule: false,
      errorList: [],
      existingModules,
      categories,
      shec_disciplines,
      deliveries
    }
  }

  componentWillReceiveProps(nextProps){
    const { name, default_frequency, category, shec_discipline, run_time, delivery, link } = nextProps.moduleData;
    this.setState({
      name,
      default_frequency,
      category,
      shec_discipline,
      run_time,
      delivery,
      link
    })

    this.handleErrorMessage(nextProps.errorMessage);
  }

  onEditModuleList() {
    let { name, default_frequency, category, shec_discipline, run_time, delivery, link } = this.state
    const trainingModule = { name, default_frequency, category };
    const newState = this.updateTrainingModule(trainingModule);

    if (newState.errorList.length > 0) return;

    const details = {
      id: this.props.moduleData.id,
      name,
      default_frequency,
      category,
      shec_discipline,
      run_time,
      delivery,
      link,
      prev_name: this.props.moduleData.name,
      prev_default_frequency: this.props.moduleData.default_frequency,
      prev_category: this.props.moduleData.category,
      include_archives: true
    }

    if (!this.hasChanges()) return;
    this.props.onEditEvent(details)
  }

  hasChanges = () => {
    const { name, default_frequency, category, shec_discipline, run_time, delivery, link } = this.state;
    const { name: prev_name, default_frequency: prev_default_frequency, category: prev_category,
      shec_discipline: prev_shec_discipline, run_time: prev_run_time, delivery: prev_delivery,
      link: prev_link } = this.props.moduleData;
    return (name !== prev_name || default_frequency !== prev_default_frequency || category !== prev_category ||
      shec_discipline !== prev_shec_discipline || run_time !== prev_run_time || delivery !== prev_delivery ||
      link !== prev_link)
  }

  onModalClose() {
    this.setState({
      name: '',
      default_frequency: '',
      category: null,
      shec_discipline: null,
      run_time: null,
      delivery: null,
      link: '',
      errorModuleName: false,
      errorDefaultFrequency: false,
      errorDuplicateModule: false,
      errorList: []
    })
  }

  onClose() {
    this.props.onClose()
    this.onModalClose()
  }

  render() {
    const { show, moduleData } = this.props
    const { errorModuleName, errorDefaultFrequency, errorCategory, errorDuplicateModule, categories, shec_disciplines, deliveries, errorList } = this.state;
    return (
      <Modal size={ 'mini' } dimmer={ 'inverted' } open={ show }>
        <Modal.Header>Edit Training Module</Modal.Header>
        <Modal.Content>
          <Form className="custom-form">
            <Form.Input fluid label='Module name' placeholder='Module name' defaultValue={moduleData.name} error={ errorModuleName || errorDuplicateModule } onChange={ (target, prop) => this.onChangeModule(prop.value) } />
            { errorDuplicateModule && <Message className="custom-message" error content="A training module with the same name already exists"/> }
            <Form.Input fluid label='Training Frequency (years)' placeholder='Years' type='number' min={0} defaultValue={moduleData.default_frequency} error={ errorDefaultFrequency } onChange={ (target, prop) => this.onChangeRefresher(prop.value) } />
            <Form.Select fluid label='Requirement' options={categories} placeholder='Requirement' defaultValue={moduleData.category} error={ errorCategory } onChange={ (target, prop) => this.onChangeCategory(prop.value) }  forceSelection={false} selectOnBlur={false}/>
            { errorList.length > 0 && <Message className="custom-message" error header="The training module requires the following values" list={errorList}/> }
            <Form.Select fluid label='SHEC Discipline' options={shec_disciplines} placeholder='SHEC Discipline' defaultValue={moduleData.shec_discipline} onChange={ (target, prop) => this.onChangeShecDiscipline(prop.value) } />
            <Form.Select fluid label='Facilitator' options={deliveries} placeholder='Facilitator' defaultValue={moduleData.delivery} onChange={ (target, prop) => this.onChangeDelivery(prop.value) } />
            <Form.Input fluid label='Runtime (hours)' placeholder='Runtime (hours)' type='number' min={0} defaultValue={moduleData.run_time} onChange={ (target, prop) => this.onChangeRunTime(prop.value) } />
            <Form.Input fluid label='Link' placeholder='Add a link' defaultValue={moduleData.link} onChange={ (target, prop) => this.onChangeLink(prop.value) }/>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            negative
            content="Cancel"
            onClick={ () => this.onClose() }
          />
          <Button
            positive
            content="Save"
            onClick={ () => this.onEditModuleList() }
          />
        </Modal.Actions>
      </Modal>
    )
  }
}

export default ModalEditV2TrainingModule;



// WEBPACK FOOTER //
// ./src/views/components/modals/edit_v2_training_module.js